{
	"navigation": {
		"moreLabel": "Mehr"
	},
	"useDeclarationCreationFormStore": {
		"errorMessages": {
			"fetchDefaultMaterial": "Material konnte nicht abgerufen werden",
			"submitDeclaration": "Erklärung konnte nicht übermittelt werden"
		}
	},
	"country": {
		"AC": "Ascension",
		"AD": "Andorra",
		"AE": "Vereinigte Arabische Emirate",
		"AF": "Afghanistan",
		"AG": "Antigua und Barbuda",
		"AI": "Anguilla",
		"AL": "Albanien",
		"AM": "Armenien",
		"AO": "Angola",
		"AQ": "Antarktis",
		"AR": "Argentinien",
		"AS": "Amerikanisch-Samoa",
		"AT": "Österreich",
		"AU": "Australien",
		"AW": "Aruba",
		"AX": "Ålandinseln",
		"AZ": "Aserbaidschan",
		"BA": "Bosnien und Herzegowina",
		"BB": "Barbados",
		"BD": "Bangladesch",
		"BE": "Belgien",
		"BF": "Burkina Faso",
		"BG": "Bulgarien",
		"BH": "Bahrain",
		"BI": "Burundi",
		"BJ": "Benin",
		"BL": "Saint-Barthélemy",
		"BM": "Bermuda",
		"BN": "Brunei",
		"BO": "Bolivien",
		"BQ": "Karibische Niederlande",
		"BR": "Brasilien",
		"BS": "Bahamas",
		"BT": "Bhutan",
		"BV": "Bouvetinsel",
		"BW": "Botswana",
		"BY": "Weißrussland",
		"BZ": "Belize",
		"CA": "Kanada",
		"CC": "Kokosinseln",
		"CD": "Kongo (Demokratische Republik)",
		"CEFTA": "CEFTA",
		"CF": "Zentralafrikanische Republik",
		"CG": "Kongo (Republik)",
		"CH": "Schweiz",
		"CI": "Elfenbeinküste",
		"CK": "Cookinseln",
		"CL": "Chile",
		"CM": "Kamerun",
		"CN": "China",
		"CO": "Kolumbien",
		"CP": "Clipperton-Insel",
		"CR": "Costa Rica",
		"CU": "Kuba",
		"CV": "Kap Verde",
		"CW": "Curaçao",
		"CX": "Weihnachtsinsel",
		"CY": "Zypern",
		"CZ": "Tschechien",
		"DE": "Deutschland",
		"DG": "Diego Garcia",
		"DJ": "Dschibuti",
		"DK": "Dänemark",
		"DM": "Dominica",
		"DO": "Dominikanische Republik",
		"DZ": "Algerien",
		"ES": "Spanien",
		"EC": "Ecuador",
		"EE": "Estland",
		"EG": "Ägypten",
		"EH": "Westsahara",
		"ER": "Eritrea",
		"CT": "Katalonien (Spanien)",
		"GA": "Galicien (Spanien)",
		"PV": "Baskenland (Spanien)",
		"ES-TR": "Spanisches Territorium",
		"ET": "Äthiopien",
		"EU": "Europäische Union",
		"FI": "Finnland",
		"FJ": "Fidschi",
		"FK": "Falklandinseln",
		"FM": "Mikronesien",
		"FO": "Färöer",
		"FR": "Frankreich",
		"GA": "Gabun",
		"ENG": "England",
		"NIR": "Nordirland",
		"SCT": "Schottland",
		"WLS": "Wales",
		"GB": "Großbritannien",
		"GD": "Grenada",
		"GE": "Georgien",
		"GF": "Französisch-Guayana",
		"GG": "Guernsey",
		"GH": "Ghana",
		"GI": "Gibraltar",
		"GL": "Grönland",
		"GM": "Gambia",
		"GN": "Guinea",
		"GP": "Guadeloupe",
		"GQ": "Äquatorialguinea",
		"GR": "Griechenland",
		"GS": "Südgeorgien und die Südlichen Sandwichinseln",
		"GT": "Guatemala",
		"GU": "Guam",
		"GW": "Guinea-Bissau",
		"GY": "Guyana",
		"HK": "Hongkong",
		"HM": "Heard und McDonaldinseln",
		"HN": "Honduras",
		"HR": "Kroatien",
		"HT": "Haiti",
		"HU": "Ungarn",
		"IC": "Kanarische Inseln",
		"ID": "Indonesien",
		"IE": "Irland",
		"IL": "Israel",
		"IM": "Isle of Man",
		"IN": "Indien",
		"IO": "Britisches Territorium im Indischen Ozean",
		"IQ": "Irak",
		"IR": "Iran",
		"IS": "Island",
		"IT": "Italien",
		"JE": "Jersey",
		"JM": "Jamaika",
		"JO": "Jordanien",
		"JP": "Japan",
		"KE": "Kenia",
		"KG": "Kirgisistan",
		"KH": "Kambodscha",
		"KI": "Kiribati",
		"KM": "Komoren",
		"KN": "St. Kitts und Nevis",
		"KP": "Nordkorea",
		"KR": "Südkorea",
		"KW": "Kuwait",
		"KY": "Kaimaninseln",
		"KZ": "Kasachstan",
		"LA": "Laos",
		"LB": "Libanon",
		"LC": "St. Lucia",
		"LI": "Liechtenstein",
		"LK": "Sri Lanka",
		"LR": "Liberia",
		"LS": "Lesotho",
		"LT": "Litauen",
		"LU": "Luxemburg",
		"LV": "Lettland",
		"LY": "Libyen",
		"MA": "Marokko",
		"MC": "Monaco",
		"MD": "Moldawien",
		"ME": "Montenegro",
		"MF": "Saint-Martin",
		"MG": "Madagaskar",
		"MH": "Marshallinseln",
		"MK": "Nordmazedonien",
		"ML": "Mali",
		"MM": "Myanmar (Birma)",
		"MN": "Mongolei",
		"MO": "Macau",
		"MP": "Nördliche Marianen",
		"MQ": "Martinique",
		"MR": "Mauretanien",
		"MS": "Montserrat",
		"MT": "Malta",
		"MU": "Mauritius",
		"MV": "Malediven",
		"MW": "Malawi",
		"MX": "Mexiko",
		"MY": "Malaysia",
		"MZ": "Mosambik",
		"NA": "Namibia",
		"NC": "Neukaledonien",
		"NE": "Niger",
		"NF": "Norfolkinsel",
		"NG": "Nigeria",
		"NI": "Nicaragua",
		"NL": "Niederlande",
		"NO": "Norwegen",
		"NP": "Nepal",
		"NR": "Nauru",
		"NU": "Niue",
		"NZ": "Neuseeland",
		"OM": "Oman",
		"PA": "Panama",
		"PE": "Peru",
		"PF": "Französisch-Polynesien",
		"PG": "Papua-Neuguinea",
		"PH": "Philippinen",
		"PK": "Pakistan",
		"PL": "Polen",
		"PM": "Saint-Pierre und Miquelon",
		"PN": "Pitcairninseln",
		"PR": "Puerto Rico",
		"PS": "Palästina",
		"PT": "Portugal",
		"PW": "Palau",
		"PY": "Paraguay",
		"QA": "Katar",
		"RE": "Réunion",
		"RO": "Rumänien",
		"RS": "Serbien",
		"RU": "Russland",
		"RW": "Ruanda",
		"SA": "Saudi-Arabien",
		"SB": "Salomonen",
		"SC": "Seychellen",
		"SD": "Sudan",
		"SE": "Schweden",
		"SG": "Singapur",
		"SH": "St. Helena, Ascension und Tristan da Cunha",
		"SI": "Slowenien",
		"SJ": "Svalbard und Jan Mayen",
		"SK": "Slowakei",
		"SL": "Sierra Leone",
		"SM": "San Marino",
		"SN": "Senegal",
		"SO": "Somalia",
		"SR": "Suriname",
		"SS": "Südsudan",
		"ST": "São Tomé und Príncipe",
		"SV": "El Salvador",
		"SX": "Sint Maarten",
		"SY": "Syrien",
		"SZ": "Swasiland",
		"SZ-2": "Eswatini",
		"TA": "Tristan da Cunha",
		"TC": "Turks- und Caicosinseln",
		"TD": "Tschad",
		"TF": "Französische Süd- und Antarktisgebiete",
		"TG": "Togo",
		"TH": "Thailand",
		"TJ": "Tadschikistan",
		"TK": "Tokelau",
		"TL": "Timor-Leste",
		"TM": "Turkmenistan",
		"TN": "Tunesien",
		"TO": "Tonga",
		"TR": "Türkei",
		"TT": "Trinidad und Tobago",
		"TV": "Tuvalu",
		"TW": "Taiwan",
		"TZ": "Tansania",
		"UA": "Ukraine",
		"UG": "Uganda",
		"US": "USA",
		"UN": "Vereinte Nationen",
		"US-2": "USA",
		"UY": "Uruguay",
		"UZ": "Usbekistan",
		"VA": "Vatikanstadt",
		"VC": "St. Vincent und die Grenadinen",
		"VE": "Venezuela",
		"VG": "Britische Jungferninseln",
		"VI": "Amerikanische Jungferninseln",
		"VN": "Vietnam",
		"VU": "Vanuatu",
		"WF": "Wallis und Futuna",
		"WS": "Samoa",
		"XK": "Kosovo",
		"YE": "Jemen",
		"YT": "Mayotte",
		"ZA": "Südafrika",
		"ZM": "Sambia",
		"ZW": "Simbabwe"
	},
	"languages": {
		"bg-BG": "Bulgarisch",
		"cs-CZ": "Tschechisch",
		"de-DE": "Deutsch",
		"en-US": "Englisch",
		"el-GR": "Griechisch",
		"es-ES": "Spanisch",
		"fr-FR": "Französisch",
		"it-IT": "Italienisch",
		"nl-NL": "Niederländisch",
		"no-NO": "Norwegisch",
		"pl-PL": "Polnisch",
		"ro-RO": "Rumänisch",
		"sv-SE": "Schwedisch"
	},
	"traceIdBadge": {
		"traceIdLabel": "Trace-ID"
	},
	"commentBox": {
		"commentInputLabel": "Kommentar hinzufügen",
		"readMore": "Mehr anzeigen",
		"dropdownActions": {
			"edit": "Bearbeiten",
			"delete": "Löschen"
		},
		"editActions": {
			"cancel": "Abbrechen",
			"done": "Fertig"
		},
		"deleteModal": {
			"title": "Kommentar löschen",
			"cancel": "Abbrechen",
			"delete": "Löschen"
		}
	},
	"units": {
		"kg": "kg",
		"ton": "t",
		"m3": "M3",
		"co2": "CO\u2082 Äq.",
		"kgCO2": "kg CO\u2082 Äq."
	}
}
